import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            fill: "currentColor",
            d: "M15 4.5c.414 0 .75.336.75.75 0 .38-.282.693-.648.743L15 6H3.5v2.75H15c.414 0 .75.336.75.75 0 .38-.282.693-.648.743L15 10.25H3.5V18h17v-6l.007-.102c.05-.366.363-.648.743-.648s.693.282.743.648L22 12v6.5c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1v-13c0-.552.448-1 1-1h12zm4.75 0c.38 0 .693.282.743.648l.007.102V6.5h1.25c.414 0 .75.336.75.75 0 .38-.282.693-.648.743L21.75 8H20.5v1.25l-.007.102c-.05.366-.363.648-.743.648s-.693-.282-.743-.648L19 9.25V8h-1.25c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743l.102-.007H19V5.25l.007-.102c.05-.366.363-.648.743-.648z",
            transform: "translate(-624 -1028) translate(624 1028)"
          })
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }